export default function Error({ children }) {
  return <p className="error">🛑 Error: {children}</p>;
}
